import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getBankingDetails, saveBankingDetails, validateBankingDetails } from '../../../actions/user.js';
import CurrentBankingDetailsModal from './CurrentBankingDetailsModal.js';
import ConfirmBankingDetails from './ConfirmBankingDetails.js';
import { Loader, Services, EditBankingDetails } from "@simplybenefits/sb-ui-library";

class Banking extends PureComponent {
    state = {
        currentBankingDetails: null,
        modalType: null, // currentBankingDetails, editBankingDetails, confirmDetails
        newBankingDetails: null
    };

    async componentDidMount() {
        const currentBankingDetails = await this.props.dispatch(getBankingDetails(this.props.meta.userID));

        this.setState({
            modalType: this.props.meta.paymentsSetup ? 'currentBankingDetails' : 'editBankingDetails',
            currentBankingDetails
        });
    }

    _showModal = (modalType) => {
        this.setState({
            modalType
        });
    };

    _saveBankingDetails = async (params) => {
        const data = {
            password: params.password,
            signage: {
                ...params.signage,
                datedOn: Services.dates.formatOutgoingDate(params.signage.datedOn)
            },
            default: this.state.newBankingDetails.default
        };

        if (this.state.newBankingDetails.useSameBankAccount === false) {
            data.paymentsOnly = this.state.newBankingDetails.paymentsOnly;
        }

        // if the member is set to CC pay then don't save a payment only account, only save reimbursement account
        if (this.props.meta.paymentType === 'CC') {
            data.paymentsOnly = null;
        }

        // make call to backend to update banking details
        const success = await this.props.dispatch(saveBankingDetails(data));

        if (success) {
            this.props.close();
        }

        return false;
    };

    render() {
        if (this.state.modalType === 'currentBankingDetails') {
            return (
                <CurrentBankingDetailsModal
                    currentBankingDetails={ this.state.currentBankingDetails }
                    showModal={ this._showModal }
                    close={ this.props.close }
                />
            );
        }

        if (this.state.modalType === 'editBankingDetails') {
            return (
                <EditBankingDetails
                    meta={ this.props.meta }
                    currentBankingDetails={ this.state.currentBankingDetails }
                    showModal={ this._showModal }
                    onBack={ () => this._showModal('currentBankingDetails') }
                    close={ this.props.close }
                    validateBankingDetails={ (...params) => this.props.dispatch(validateBankingDetails(...params)) }
                    bankingDetailsVerifying={ this.props.bankingDetailsVerifying }
                    saveNewBankingDetails={ (newBankingDetails) => {
                        this.setState({
                            newBankingDetails
                        });
                    }}
                    whitelabel={ this.props.whitelabel }
                />
            );
        }

        if (this.state.modalType === 'confirmDetails') {
            return (
                <ConfirmBankingDetails
                    newBankingDetails={ this.state.newBankingDetails }
                    onBack={ () => this._showModal('editBankingDetails') }
                    close={ this.props.close }
                    saveBanking={ (params) => this._saveBankingDetails(params) }
                    loader={ this.props.loader }
                    whitelabel={ this.props.whitelabel }
                />
            );
        }
        
        return <Loader/>;
    }
}

Banking.propTypes = {
    meta: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    bankingDetailsVerifying: state.user.bankingDetailsVerifying,
    meta: state.user.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Banking);